import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

function LinkButton(props) {
  const { path, linktext } = props;
  return (
    <Link
      to={path}
      className="bg-buttons-private rounded-md p-2 px-6 text-gray-300 xl:text-lg md:text-md text-sm font-300 hover:bg-private-link"
    >
      {linktext}
    </Link>
  );
}

export default LinkButton;

LinkButton.propTypes = {
  path: PropTypes.string.isRequired,
  linktext: PropTypes.string.isRequired,
};
